define('lib/leaflet-small-map/leaflet-small-map',['leaflet', 'lib/leaflet-small-map/leaflet-small-map-helpers'], function(
  L,
  LeafletSmallMapHelpers
) {
  return function LeafletSmallMap(map, options) {
    this.setup = function() {
      this.hideMapElements();

      this.createElements();
    };

    this.hideMapElements = function() {
      document.querySelector('.webgis-container').classList.add('webgis-small-map');
    };

    this.createElements = function() {
      var mapEl = document.getElementById(map._container.id);
      this.container = LeafletSmallMapHelpers.createDomElement('div', {
        cssClass: 'lsm__container',
      });
      this.infoButton = LeafletSmallMapHelpers.createDomElement('div', {
        cssClass: 'lsm__info-button',
        content: '<i class="lsm__icon-button fas fa-info fa-lg"></i>',
        clickCallback: this.showInfo.bind(this),
      });
      this.largeMapButton = LeafletSmallMapHelpers.createDomElement('div', {
        cssClass: 'lsm__large-map-button',
        title: 'Visa större karta',
        content: '<i class="lsm__icon-button fas fa-external-link-alt fa-lg"></i>',
        clickCallback: this.showLargeMap.bind(this),
      });

      this.infoDialog = this.createInfoDialog();
      this.infoDialogBackdrop = LeafletSmallMapHelpers.createDomElement('div', {
        cssClass: 'lsm__info-dialog-backdrop',
      });

      this.container.appendChild(this.infoButton);
      this.container.appendChild(this.largeMapButton);
      mapEl.appendChild(this.container);
      mapEl.appendChild(this.infoDialog);
      mapEl.appendChild(this.infoDialogBackdrop);
    };

    this.createInfoDialog = function() {
      var infoDialog = LeafletSmallMapHelpers.createDomElement('div', {
        cssClass: 'lsm__info-dialog',
      });
      var header = LeafletSmallMapHelpers.createDomElement('header', {
        cssClass: 'lsm__info-dialog-header',
        content: options.mapInfo.title,
      });
      var closeButton = LeafletSmallMapHelpers.createDomElement('div', {
        cssClass: 'lsm__info-dialog-close',
        content: '<i class="fas fa-times"></i>',
        clickCallback: this.hideInfo.bind(this),
      });
      var body = LeafletSmallMapHelpers.createDomElement('div', {
        cssClass: 'lsm__info-dialog-body',
        content: options.mapInfo.description,
      });
      var attributions = LeafletSmallMapHelpers.createDomElement('div', {
        cssClass: 'lsm__info-dialog-attributions',
        content: Object.keys(map.attributionControl._attributions).join('<br>'),
      });

      header.appendChild(closeButton);
      infoDialog.appendChild(header);
      body.appendChild(attributions);
      infoDialog.appendChild(body);
      return infoDialog;
    };

    this.showInfo = function() {
      map.dragging.disable();
      document.querySelector('.webgis-container').classList.add('webgis-small-info-dialog');
    };
    this.hideInfo = function() {
      map.dragging.enable();
      document.querySelector('.webgis-container').classList.remove('webgis-small-info-dialog');
    };

    this.showLargeMap = function() {
      var mapPageName = options.configPath.replace('configs/', '').replace('.js', '');
      window.open(mapPageName + '.html');
    };

    this.setup();
  };
});

